module.exports = __webpack_public_path__ + "static/media/test3_3.8b514cfd.png";